var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatIconHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.4C0 1.7635 0.2529 1.153 0.7029 0.7029C1.153 0.2529 1.7635 0 2.4 0H21.6C22.2365 0 22.847 0.2529 23.2971 0.7029C23.7471 1.153 24 1.7635 24 2.4V14.4C24 15.0365 23.7471 15.647 23.2971 16.0971C22.847 16.5471 22.2365 16.8 21.6 16.8H2.4C1.7635 16.8 1.153 16.5471 0.7029 16.0971C0.2529 15.647 0 15.0365 0 14.4V2.4ZM2.4 3.816V13.2C2.4 13.5183 2.5264 13.8235 2.7515 14.0485C2.9765 14.2736 3.2817 14.4 3.6 14.4H20.4C20.7183 14.4 21.0235 14.2736 21.2485 14.0485C21.4736 13.8235 21.6 13.5183 21.6 13.2V3.816L12 9.816L2.4 3.816ZM19.3356 2.4H4.6644L12 6.984L19.3356 2.4Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIconHeader);
export default __webpack_public_path__ + "static/media/chatIconHeader.9732f619aa395ba7d8f7da5a81ab236e.svg";
export { ForwardRef as ReactComponent };